<template>
  <div id="bloco-conteudo" class="d-flex align-center justify-space-between py-1">
    <div>
      <span class="font-weight-medium">Média trimestre: </span> {{ Helpers.formatarValor(dados.media_trimestre) }}
    </div>

    <div>
      <span class="font-weight-medium">Média semestre: </span> {{ Helpers.formatarValor(dados.media_semestre) }}
    </div>

    <div>
      <span class="font-weight-medium">Projeção de vendas: </span> {{ Helpers.formatarValor(dados.projecao_vendas) }}
    </div>
  </div>
</template>

<script>
import {buscarMediasMensaisEProjecao} from "@/api/compraPorProdutosGerais/Heranca";
import {logout} from "@/helpers";

export default {
  name: "MediasEProjecao",
  props: {
    produto: Object,
  },
  data: () => ({
    dados: {
      media_trimestre: 0,
      media_semestre: 0,
      projecao_vendas: 0,
    }
  }),
  watch: {
    'produto.produto': function () {
      this.buscarDados();
    }
  },
  mounted() {
    this.buscarDados();
  },
  methods: {
    buscarDados() {
      buscarMediasMensaisEProjecao(this.produto)
        .then(dados => (this.dados = dados))
        .catch(logout)
    }
  }
}
</script>

<style scoped>
#bloco-conteudo {
  background: #f2f2f2;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
}
</style>
